import * as STD     from '@emersya/mpa-std-lib';
import EngineModule from '../../../EngineModule';
import {
	NS as StandingPartitionsHeadsNS
}                   from '../../../components/customers/standing/StandingPartitionsHeadsPrestige/StandingPartitionsHeadsPrestige';

export default () => new EngineModule.UIEngineModule({
	type :             'ui',
	id :               'standing-partitionsHeadsPrestige',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	modulesBefore :    [
		'product-editor',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor',
		'viewer-planner-floor-editor',
		'viewer-planner-walls-editor',
		'standing-highSign'
	],
	modulesAfter :     [
		'standing-banner',
		'viewer-planner-furniture-editor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	usableCondition :  {
		type : 'and',
		LHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  'TARGET.basket.currentProduct',
			value :     null
		},
		RHS :  {
			type :      'notequal',
			component : 'K.basket',
			property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
			value :     null
		}
	},
	displayCondition : {
		type : 'and',
		LHS :  {
			type : 'and',
			LHS : {
				type :      'notequal',
				component : 'K.basket',
				property :  'TARGET.basket.currentProduct',
				value :     null
			},
			RHS : {
				type : 'or',
				LHS : {
					type :      'equal',
					component : 'K.basket',
					property :  'TARGET.basket.currentProduct.id',
					value :     'confort'
				},
				RHS : {
					type :      'equal',
					component : 'K.basket',
					property :  'TARGET.basket.currentProduct.id',
					value :     'prestige'
				}
				
			}
		},
		RHS :  {
			type : 'or',
			LHS :  {
				type :      'equal',
				component : 'K.basket',
				property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
				value :     null
			},
			RHS :  {
				type : 'and',
				LHS :  {
					type :      'notequal',
					component : 'K.basket',
					property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
					value :     null
				},
				RHS :  {
					type :      'notequal',
					component : 'K.basket',
					property :  '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption.id',
					value :     'shape-no-wall'
				}
			}
		}
	},
	generateComponentConfiguration() : StandingPartitionsHeadsNS.Configuration {
		if (!this.translations.text) {
			throw STD.errors.user('');
		}
		return {
			text :                 this.translations.text,
		};
	},
	async initialize() {
	}
});
